import React, { useEffect, useState } from "react";
import { Key } from "ts-key-enum";

import { BreakPoint } from "../../../models/screen.interfaces";
import { getViewportBreakpoint } from "../../../utils/detectMobile";
import { GridSorterConfig } from "../sorters";

import styles from "./GridSort.module.scss";

export enum GridFilterVariants {
    ACCORDION = "accordion",
    DROPDOWN = "dropdown",
}

interface IProps {
    sorters: GridSorterConfig[];
    sortMethod: string | null;
    onChangeSortMethod: (sortMethod: string) => void;
}

export const GridSort = React.memo(
    ({ sorters, sortMethod, onChangeSortMethod }: IProps): React.ReactNode => {
        const [isOpen, setIsOpen] = useState(true);

        useEffect(() => {
            const currentBreakpoint = getViewportBreakpoint();
            setIsOpen(currentBreakpoint > BreakPoint.MEDIUM);
        }, []);

        const onTitleEvent = (
            event:
                | React.MouseEvent<HTMLElement>
                | React.KeyboardEvent<HTMLElement>,
        ) => {
            event.preventDefault();
            setIsOpen((prevIsOpen) => !prevIsOpen);
        };

        const onKeyPressHandler = (event: React.KeyboardEvent<HTMLElement>) => {
            if (event.key === Key.Enter) {
                onTitleEvent(event);
            }
        };

        return (
            <fieldset className={styles.sortContainer}>
                <legend
                    onClick={onTitleEvent}
                    role="button"
                    tabIndex={0}
                    onKeyPress={onKeyPressHandler}
                    aria-expanded={isOpen}
                    className={styles.header}
                >
                    Sort By
                </legend>
                {sorters && isOpen && (
                    <select
                        id="sorter"
                        value={sortMethod || ""}
                        onChange={(e) => {
                            onChangeSortMethod(e.currentTarget.value);
                        }}
                        className={styles.sortBody}
                    >
                        {sorters.map((sorter) => (
                            <option key={sorter.id} value={sorter.id}>
                                {sorter.label}
                            </option>
                        ))}
                    </select>
                )}
            </fieldset>
        );
    },
);
